import React from 'react';
import PropTypes from 'prop-types';

import ItemName from "components/List/components/ItemName";

import {capitalize} from "utils/capitalize";

import {greyishBlue500} from "assets/jss/main";

RetailerNameCell.propTypes = {
    retailer: PropTypes.object.isRequired,
};

function RetailerNameCell({retailer}) {
    return (
        <div style={{overflow: 'hidden', lineHeight: '16px'}}>
            <div style={{overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>
                <ItemName label={capitalize(retailer.name)}/>
            </div>
            {retailer.paymentAccount && retailer.paymentAccount.accountId &&
                <div style={{
                    fontSize: '12px',
                    color: greyishBlue500,
                    fontWeight: 400,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                }}>
                    {retailer.paymentAccount.accountId}
                </div>
            }
        </div>
    );
}

export default RetailerNameCell;
